import { Divider } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';
import { EmployerCard as EmployerCardData } from '@common-types';

import { StyledEmployerCard, StyledEmployerLink, StyledEmployerLogo, sxStyles } from './EmployerCard.styles';

export const EMPLOYER_CARD_DESCRIPTION_CHAR_LIMIT = 138;

export interface EmployerCardProps {
  employer: Pick<EmployerCardData, 'name' | 'logo' | 'description'>;
  employerUrl: string;
}

export const EmployerCard = ({ employer, employerUrl }: EmployerCardProps) => {
  const fullDescription = employer.description || '';
  const description = fullDescription.substring(0, EMPLOYER_CARD_DESCRIPTION_CHAR_LIMIT);
  const hasMore = fullDescription.length > description.length;

  return (
    <StyledEmployerLink href={employerUrl} target="_blank" rel="noreferrer">
      <StyledEmployerCard>
        <CoreBox sx={sxStyles.employerLogoCover}>
          <StyledEmployerLogo src={employer.logo} alt={`${employer.name} logo`} />
        </CoreBox>
        <Divider />
        <CoreBox sx={sxStyles.employerContent}>
          <CoreTypography sx={sxStyles.employerTitle} component="div" variant="h5">
            {employer.name}
          </CoreTypography>
          <CoreTypography variant="body1" sx={sxStyles.employerDescription}>
            {description}
            {hasMore ? (
              <>
                ...&nbsp;
                <CoreTypography component="span" variant="body1" color="primary">
                  See more
                </CoreTypography>
              </>
            ) : null}
          </CoreTypography>
        </CoreBox>
      </StyledEmployerCard>
    </StyledEmployerLink>
  );
};
